import React from 'react'
import { Header } from '../templates/Header'
import { Footer } from '../templates/Footer'
const Privacypolicy = () => {
   return (
      <>
         <Header />
         <section className="Shipping-Sec">
            <div className="alway_home_li">
               <ul className="return_back_home Privacy">
                  <li>
                     <a href="">Home</a>
                  </li>
                  <li><i className="fa-solid fa-angle-right"></i></li>
                  <li> Privacy Policy</li>
               </ul>
            </div>
            <div className="stat-bnr">
               <img src="../../images/shipping_static.jpg" />
            </div>
            <div className="offset_heading_shep">
               <h3>Your Privacy - Our Commitment</h3>
            </div>

         </section>
         <section className="shipping_conditions policy">
            <div className=" ">
               <div className="conditions">
                  <ol start="1">
                     <li><strong>General</strong></li>
                  </ol>
                  <ul>
                     <li>At ACE Healthcare, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, disclose, and protect the information gathered through our website and services.</li>
                  </ul>
                  {/* <ul></ul> */}
                  <ol start="2">
                     <li><strong>Information Collection and Use:</strong></li>
                  </ol>
                  <ul>
                     <li>
                        We may collect personal information including name, email address,
                        mobile number, delivery address, account information, order history,
                        and device information when you interact with our website or mobile
                        application.
                     </li>
                     <li>
                        This information is used for account management, order processing,
                        customer support, service improvement, communication, and legal
                        compliance purposes.
                     </li>
                  </ul>
                  <ol start="6">
                     <li><strong> Cookies Policy</strong></li>
                  </ol>
                  <p>Our website may use cookies to enhance your browsing experience and analyze usage patterns. Cookies are small files stored on your device that track information about your visit. You can control the use of cookies through your browser settings, but please note that disabling cookies may affect the functionality of our website.</p>
                  <ol start="5">
                     <li><strong> Data Security</strong></li>
                  </ol>
                  <p>We employ industry-standard security measures to safeguard your personal information against unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is entirely secure, and we cannot guarantee absolute security.</p>
                  <ol start="5">
                     <li><strong> Third-Party Links:</strong></li>
                  </ol>
                  <p>Our website may contain links to third-party websites or services that are not operated by ACE Healthcare. We are not responsible for the privacy practices or content of these third-party sites. We encourage you to review the privacy policies of any third-party sites you visit.</p>
                  <ol start="5">
                     <li><strong> Children's Privacy:</strong></li>
                  </ol>
                  <p>ACE Healthcare does not knowingly collect personal information from children under the age of 13. If you believe that we have inadvertently collected personal information from a child under 13, please contact us immediately, and we will take steps to remove the information promptly.</p>
                  <ol start="5">
                     <li><strong> Changes to this Privacy Policy:</strong></li>
                  </ol>
                  <p>We reserve the right to update or revise this Privacy Policy at any time. Any changes will be posted on this page, and the effective date will be updated accordingly. We encourage you to review this Privacy Policy periodically for any updates.</p>

                  <ol start="8">
                     <li><strong>Data Retention</strong></li>
                  </ol>
                  <p>
                     ACE Healthcare retains personal information only for as long as necessary
                     to provide services, comply with legal obligations, resolve disputes,
                     and enforce agreements.
                  </p>
                  <p>
                     User account information, order history, and related records may be
                     retained while the account remains active. Upon receiving a valid
                     account or data deletion request, personal data will be deleted or
                     anonymized within 30 days unless retention is required by applicable law.
                  </p>

                  <ol start="9">
                     <li><strong>Data Deletion Request</strong></li>
                  </ol>
                  <p>
                     Users may request deletion of their account and personal data at any time.
                  </p>
                  <p>
                     To request deletion, users can contact us by email at
                     <strong> acehealthcare2023@gmail.com </strong>
                     or call us at
                     <strong> 9056813248</strong>.
                  </p>
                  <p>
                     After verification of the request, ACE Healthcare will process the
                     deletion request within 30 days unless retention is required by law
                     or regulatory obligations.
                  </p>

                  <ol start="10">
                     <li><strong>Contact Us</strong></li>
                  </ol>
                  <p>
                     If you have any questions or concerns about this Privacy Policy or our
                     data practices, please contact us:
                  </p>

                  <p>
                     <strong>ACE Healthcare</strong>
                     <br />
                     Email: acehealthcare2023@gmail.com
                     <br />
                     Phone: 9056813248
                     <br />
                     Website: https://www.acehealthcare.co.in
                  </p>

                  <p>
                     By using our website and services, you consent to the terms outlined in
                     this Privacy Policy. Thank you for choosing ACE Healthcare.
                  </p>
               </div>
            </div>
         </section>
         <Footer />
      </>
   )
}

export default Privacypolicy